import { render } from "./LeftDesktopBar.vue?vue&type=template&id=22116e08&scoped=true"
import script from "./LeftDesktopBar.vue?vue&type=script&lang=js"
export * from "./LeftDesktopBar.vue?vue&type=script&lang=js"

import "./LeftDesktopBar.vue?vue&type=style&index=0&id=22116e08&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22116e08"]])

export default __exports__